import Hamburger from 'components/Hamburger';
import Logo from 'components/Logo';

import styles from './styles.module.scss';

const Header = ({ shouldHideNavigation = false }) => {
    const isHomePage = window.location.pathname === '/';
    return (
        <header
            className={`${styles.header} ${
                isHomePage ? styles.headerFixed : ''
            }`}
            data-gtm="nav"
        >
            <div className={styles.headerContent}>
                <Logo
                    className={`${styles.logo} ${
                        shouldHideNavigation ? styles.logoCentered : ''
                    }`}
                />

                {!shouldHideNavigation && <Hamburger />}
            </div>
        </header>
    );
};

export default Header;
